import React from "react";
import "./App.css";

export default function App() {
  return (
    <main className="page">
      {/* Full-screen animated blobs (behind card, above page background) */}
      <div className="blobs" aria-hidden="true">
        <div className="blob blob--a" />
        <div className="blob blob--b" />
        <div className="blob blob--c" />
      </div>

      {/* Card wrapper so aura can extend outside */}
      <section className="cardWrap">
        <div className="card">
          <div className="card__inner">
            <h1 className="title">Rhys Wijeratne</h1>

            <p className="blurb">
              MEng Design Engineering at Imperial College London
            </p>

            <p className="subtitle">This site is under construction.</p>

            <div className="buttons">
              <a
                className="btn"
                href={`${process.env.PUBLIC_URL}/rhyswijeratne_portfolio.pdf`}
                download
              >
                Download portfolio (PDF)
              </a>
              <a
                className="btn"
                href={`${process.env.PUBLIC_URL}/rhyswijeratne_cv.pdf`}
                download
              >
                Download CV (PDF)
              </a>

              <a
                className="miniCard"
                href="mailto:rhys.wijeratne@gmail.com"
              >
                Email me
                <span className="miniCard__hint">mailto</span>
              </a>
                        </div>

            <p className="fineprint">
              If a link doesn’t download, right click → “Save link as…”
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
